import React, { Fragment } from 'react';
import {
    Button,
    Checkbox,
    Form, Grid,
    GridColumn,
    Header,
    Icon, Label,
    Loader,
    Popup,
    Responsive,
    Segment, Select,
    Tab,
    Table
} from 'semantic-ui-react';
import _ from 'lodash'
import axios from 'axios';
import {Redirect} from 'react-router';
import {FormattedMessage} from 'react-intl';
import {toast, ToastContainer} from 'react-toastify';

import {FiltersOnStyle, HeaderCursor, IconHeader} from './css';
import Filters from './Filters';

import ResultsPerPageDropdown from '../../Assets/util/ResultsPerPageDropdown';
import PaginationSegment from '../../Assets/util/PaginationSegment';
import {DEFAULT_NUMBER_OF_ITEMS_PER_PAGE} from '../../Assets/util/util';
import PaginationFront from '../../util/PaginationFront';
import SearchTableData from '../../util/SearchTableData';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;

// axios.defaults.crossDomain = true;

const NoCurrentGradesMessage = () => <p><FormattedMessage id="professorInputGrades.CurrentGradesMessage" /></p>;
const NoCurrentGradesFilterMessage = () => <p><FormattedMessage id="professorInputGrades.CurrentGradesFilterMessage" /></p>;

export default class StudentsWithoutGrades extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [...this.props.data],
            allUngradedStudents: [],
            results: [],
            selectedData: [],
            grade: 8,
            groupGrade: '',
            clearData:  [...this.props.data],

            showFiltersOnButton: false,
            showNoGradesFilterMode: false,
            showGradesMode: false,
            grading: false,

            showStudentInfo: false,
            studentId: '',
            sspId: '',
            studyProgramId: '',

            page: 0,
            postsPerPage:  JSON.parse(localStorage.getItem('postsPerPageTab0')),
            activePage: 1,

            loading: false,
            loadGrading: false,
            activeIndex: 0,

            resetValue: false,
            //front filter properties
            filterDataMode: false

        };


        this.handleGradeChange = this.handleGradeChange.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.confirmGrade = this.confirmGrade.bind(this);
        this.cancel = this.cancel.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.onSelectRow = this.onSelectRow.bind(this);
        this.handleResultsPerPageChange = this.handleResultsPerPageChange.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.groupGrading = this.groupGrading.bind(this);
        this.getResults = this.getResults.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevState.data !== this.props.data){
            let {departmentId, studyProgramBasicId, studyType, sortingOption}= this.state;
            this.props.frontFilterData(this.props.data, departmentId, studyProgramBasicId, studyType ? studyType.id : null, sortingOption, false)
            this.setState({
                data:this.props.data,
                results: [],
            },()=>{
                this.setState({ grading: false, rowLoader: false, showGradesMode: null, grade: 8 });
            })
        }
    }

    getDataToRender() {

        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        if (this.state.activeIndex === 1) {
            return this.props.allUngradedStudents;
        }
        if (this.state.filterDataMode) {
            return this.props.filterData;
        }

        return this.state.data;
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })

    handleGradeChange({ value }, index) {
        this.setState({ grading: true, grade: value, showGradesMode: index });
    }

    cancel(index) {
        if (this.state.showGradesMode === index) {
            this.setState({ grading: false, showGradesMode: null, grade: 8 });
        }
    }


    confirmGrade(studentGradedActivityId, studentMarkId, markId, index) {

        this.setState({showGradesMode: index, grading: true, rowLoader: true, selectedData: this.state.selectedData.filter(el=> el.studentGradedActivityId !== studentGradedActivityId)})
        axios.post(`professor/grade-student/${studentGradedActivityId}/${markId}`)
            .then(res => {
                this.props.getStudentsForGroupGrading();
                this.props.getAllStudents(localStorage.getItem('gradedActivityId'), false);
                this.props.getAllStudents(localStorage.getItem('gradedActivityId'), true);


            }).then(()=>{
            toast(<FormattedMessage id="professorInputGrades.toastStudentGraded" />);
        })
            .catch(err => {
                console.log('Pogrešno!');
                this.props.getStudentsForGroupGrading();
                this.props.getAllStudents(localStorage.getItem('gradedActivityId'), false);
                this.props.getAllStudents(localStorage.getItem('gradedActivityId'), true);

                //this.setState({ grading: false, rowLoader: false, showGradesMode: null, grade: 8 });
                // toast(<FormattedMessage id="professorInputGrades.toastStudentGradedFailed" />);
            });
    }

    groupGrading() {
        this.setState({loadGrading: true});
        let list = [];
        this.state.selectedData.map(el=> list.push(el.studentGradedActivityId));

        axios.post(`professor/grade-student/${this.state.groupGrade}`, [...list])
            .then(res => {
                toast(<FormattedMessage id="professorInputGrades.toastStudentsGraded" />);
                this.props.getStudentsForGroupGrading();
                this.props.getAllStudents(localStorage.getItem('gradedActivityId'), false);
                this.props.getAllStudents(localStorage.getItem('gradedActivityId'), true);
                this.setState({ grading: false, showGradesMode: null, grade: 8, groupGrade: '', selectedData: [], loadGrading: false });
            })
            .catch(err => {
                console.log('Pogrešno!');
                toast(<FormattedMessage id="professorInputGrades.toastStudentsGraded" />);
                this.props.getStudentsForGroupGrading();
                this.props.getAllStudents(localStorage.getItem('gradedActivityId'), false);
                this.props.getAllStudents(localStorage.getItem('gradedActivityId'), true);
                this.setState({ grading: false, showGradesMode: null, grade: 8, groupGrade: '', selectedData: [], loadGrading: false });
                // toast(<FormattedMessage id="professorInputGrades.toastStudentsGradedFailed" />);
            });
    }

    handleResultsPerPageChange(e, { value }) {
            if(value === 0){
                localStorage.setItem('postsPerPageTab0', JSON.stringify(this.getDataToRender().length));
                this.setState({ activePage: 1, postsPerPage: this.getDataToRender().length });
            }else{
                localStorage.setItem('postsPerPageTab0', JSON.stringify(value));
                this.setState({ activePage: 1, postsPerPage: value  });
            }

        }

    selectAll() {
        const { selectedData } = this.state;
        // deselect all if data.length === selectedData.length
        if (selectedData.length === this.getDataToRender().length) {
            this.setState({ selectedData: [] });
        } else {
            this.setState({ selectedData: this.getDataToRender() });
        }
    }

    onSelectRow(studentGradedActivityId) {
        const row = this.getDataToRender().find(el => el.studentGradedActivityId === studentGradedActivityId);
        const pos = this.state.selectedData.findIndex(el => el.studentGradedActivityId === row.studentGradedActivityId);
        if (pos === -1) {
            // add to selectedData
            this.setState({ selectedData: [...this.state.selectedData, row] });
        } else {
            // remove from selectedData
            const newSelectedData = this.state.selectedData.filter(el => el.studentGradedActivityId !== row.studentGradedActivityId);
            this.setState({ selectedData: newSelectedData });
        }
    }

    handleTabChange(e, { activeIndex }) {
        this.setState({ activeIndex });
    }

    handleChange = (e, { name, value }) => this.setState({ [name]: value });

    handleInputChange(e, { name, value }) {

            this.setState({ [name]: value, resetValue: true },()=>{
                let {departmentId, studyProgramBasicId, studyType, sortingOption}= this.state;
                this.setState({filterDataMode:true});
                this.props.frontFilterData(this.props.data, departmentId, studyProgramBasicId, studyType?studyType.id:null, sortingOption, false)
            });
    }

    getResults(results) {
        this.setState({ results, resetValue: false });
        this.handlePaginationChange({}, {activePage: 1})
    }

    render() {

        // Get current posts
        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);

        const panes = [
            {
                menuItem: { content: <FormattedMessage id="professorInputGrades.individuallyGrading" /> },
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <div>

                        {(!this.state.showNoGradesFilterMode && this.getDataToRender().length > 0) && <ResultsPerPageDropdown
                            resultsPerPage={this.state.postsPerPage === this.getDataToRender().length ? 0 : this.state.postsPerPage}
                            onResultsPerPageChange={this.handleResultsPerPageChange}
                        />
                        }
                        <br/>  <br/>

                        {this.state.loading ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div> :


                                <Table celled selectable>
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell colSpan={20}>
                                                {/*<div style={{ paddingLeft: '30px' }}>*/}
                                                <Grid columns={1}>
                                                    <Grid.Column>
                                                        <SearchTableData profMozilla data={this.getDataToRender()} getResults={this.getResults} resetValue={this.state.resetValue} disabled={this.state.disabledFilter} filterItem={['index','firstName', 'lastName','name','studyProgramBasicName']}/>
                                                    </Grid.Column>
                                                </Grid>
                                                 {/*</div>*/}
                                            </Table.HeaderCell>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.HeaderCell colSpan={20}>
                                                    <Form>
                                                        <Form.Group  widths="equal">
                                                            <Form.Field
                                                                clearable
                                                                width={4}
                                                                required
                                                                control={Select}
                                                                placeholder="Odsjek"
                                                                value={this.state.departmentId}
                                                                name="departmentId"
                                                                options={this.props.departments}
                                                                onChange={this.handleInputChange}
                                                            />
                                                            <Form.Field
                                                                clearable
                                                                width={4}
                                                                required
                                                                control={Select}
                                                                placeholder="Studijski program"
                                                                value={this.state.studyProgramBasicId}
                                                                name="studyProgramBasicId"
                                                                options={this.props.studyPrograms}
                                                                onChange={this.handleInputChange}
                                                            />
                                                            <Form.Field
                                                                clearable
                                                                width={4}
                                                                required
                                                                control={Select}
                                                                placeholder="Tip studiranja"
                                                                value={this.state.studyType}
                                                                name="studyType"
                                                                options={this.props.studyTypes}
                                                                onChange={this.handleInputChange}
                                                            />
                                                            <Form.Field
                                                                clearable
                                                                width={4}
                                                                required
                                                                control={Select}
                                                                placeholder="Sortiranje"
                                                                value={this.state.sortingOption}
                                                                name="sortingOption"
                                                                options={this.props.sortingOptions}
                                                                onChange={this.handleInputChange}
                                                            />
                                                            {/*<Form.Field>*/}
                                                            {/*    <Button*/}
                                                            {/*        basic*/}
                                                            {/*        color={'blue'}*/}
                                                            {/*        onClick={()=>{*/}
                                                            {/*            this.setState({filterDataMode:true});*/}
                                                            {/*            this.props.frontFilterData(this.state.data, departmentId, studyProgramBasicId, studyType.id)*/}
                                                            {/*        }}*/}
                                                            {/*    >Filtriraj</Button>*/}
                                                            {/*</Form.Field>*/}

                                                        </Form.Group>

                                                    </Form>


                                            </Table.HeaderCell>
                                        </Table.Row>

                                                <Table.Row>
                                                    <Table.HeaderCell>R. br.</Table.HeaderCell>
                                                    <Table.HeaderCell colSpan={3} >
                                                    <FormattedMessage id="common.index" />
                                                    </Table.HeaderCell>
                                                    <Table.HeaderCell
                                                        verticalAlign="middle"
                                                        colSpan={3}
                                                    >
                                                        <FormattedMessage id="common.lastName"/>
                                               </Table.HeaderCell>
                                                    <Table.HeaderCell colSpan={3} verticalAlign="middle">
                                                        <FormattedMessage id="common.firstName"/>
                                                    </Table.HeaderCell>
                                            <Table.HeaderCell colSpan={4}>
                                                <FormattedMessage id="professorInputGrades.studyProgram" />
                                            </Table.HeaderCell>
                                            <Table.HeaderCell colSpan={3}><FormattedMessage id="common.grade" /></Table.HeaderCell>
                                            <Table.HeaderCell colSpan={3}></Table.HeaderCell>

                                        </Table.Row>
                                    </Table.Header>
                                    {currentPosts.length ?
                                    <Table.Body> { currentPosts.map((el, index) =>
                                        (<Table.Row key={el.studentGradedActivityId} style={HeaderCursor}>
                                                <Table.Cell verticalAlign="middle" >
                                                    {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}.
                                                </Table.Cell>
                                                <Table.Cell
                                                    colSpan={3}
                                                    verticalAlign="middle"
                                                >
                                                    <Grid columns={2} centered stackable>
                                                        <Grid.Column width="10">
                                                            {el.index}
                                                        </Grid.Column>
                                                        <Grid.Column verticalAlign="middle" textAlign="right" width="6">
                                            <span>
                                                {<Popup content={el.studyType} hideOnScroll position="top center" trigger={<span style={{ color: '#a6a4a1' }}>
                                                    {el.studyType === 'redovan-samofinansirajući' && 'RSF'}
                                                    {el.studyType === 'redovan' && 'R'}
                                                    {el.studyType === 'vanredan' && 'V'}
                                                    {el.studyType === 'paralelan' && 'P'}
                                                    {el.studyType === 'DL studij' && 'DL'}

                                                </span>} />}
                                                   </span>
                                                        </Grid.Column>
                                                    </Grid>



                                                </Table.Cell>

                                            <Popup content={<FormattedMessage id="professorInputGrades.showStudentInfo" />} hideOnScroll position="top center" trigger={
                                                <Table.Cell
                                                    colSpan={3}
                                                    verticalAlign="middle"
                                                    onClick={() => this.setState({
                                                        studentId: el.studentId, sspId: el.studentStudyProgramId, studyProgramId: el.studyProgramId, showStudentInfo: true
                                                    })}
                                                >
                                                    {el.lastName}
                                                </Table.Cell>


                                            }/>

                                            <Popup content={<FormattedMessage id="professorInputGrades.showStudentInfo" />} hideOnScroll position="top center" trigger={

                                                <Table.Cell
                                                    colSpan={3}
                                                    verticalAlign="middle"
                                                    onClick={() => this.setState({
                                                        studentId: el.studentId, sspId: el.studentStudyProgramId, studyProgramId: el.studyProgramId, showStudentInfo: true
                                                    })}
                                                >
                                                    {el.firstName}
                                                </Table.Cell>


                                            }/>

                                                <Table.Cell
                                                    colSpan={4}
                                                    verticalAlign="middle"
                                                >
                                                    {

                                                        el.departments ? el.departments.map(e => (<div>

                                                                {e.name === el.studyProgramBasicName?
                                                                    e.name
                                                                    :

                                                                    e.name && e.name !== '-'?
                                                                        //ima odsjek i nije crtica
                                                                        <span>
                                                <strong>{e.name}</strong> <span> {el.studyProgramBasicName && el.studyProgramBasicName !== '-' ? (' | ' + el.studyProgramBasicName) : ''}</span>
                                            </span>
                                                                        :
                                                                        //nema odsjek ili je crtica
                                                                        el.studyProgramBasicName ? el.studyProgramBasicName : ''

                                                                }
                                                            </div>
                                                        )) : el.studyProgramBasicName ? el.studyProgramBasicName :''

                                                    }
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle" colSpan={3}>
                                                    {
                                                         <Form.Dropdown
                                                            disabled={this.state.grading && this.state.showGradesMode !== el.index}
                                                            placeholder={<FormattedMessage id="professorInputGrades.selectGrade" />}
                                                            value={this.state.showGradesMode !== el.index ? 8 : this.state.grade}
                                                            onChange={(e, event) => this.handleGradeChange(event, el.index)}
                                                            name="grade"
                                                            options={this.props.marks.filter(el => (el.key_ !== 'nz' && el.key_ !== 'no' && el.key_ !== 'nonp' && el.key_ !== 'f' && el.key_ !== 'not_defended' && el.key_ !== 'uo'  ))}
                                                            search
                                                            fluid
                                                        />}
                                                </Table.Cell>
                                                <Table.Cell textAlign="center" verticalAlign="middle" colSpan={3}>
                                                    {
                                                         <div>
                                                            <Popup
                                                                content={<FormattedMessage id="professorInputGrades.confirmGrade" />}
                                                                position="top center"
                                                                trigger={
                                                                    <Button
                                                                        loading={this.state.rowLoader && this.state.showGradesMode === el.index}
                                                                        disabled={this.state.grading && this.state.showGradesMode !== el.index}
                                                                        basic="true"
                                                                        circular
                                                                        icon="check"
                                                                        size="small"
                                                                        color="green"
                                                                        onClick={
                                                                            () => {
                                                                                this.confirmGrade(el.id, el.studentMarkId, this.state.grade, el.index);
                                                                            }
                                                                        }
                                                                    >
                                                                    </Button>
                                                                }
                                                            />
                                                            <Popup
                                                                content={<FormattedMessage id="common.cancelO" />}
                                                                position="top center"
                                                                trigger={
                                                                    <Button
                                                                        disabled={this.state.rowLoader || (this.state.grading && this.state.showGradesMode !== el.index)}
                                                                        basic="true"
                                                                        circular
                                                                        icon="close"
                                                                        size="small"
                                                                        color="red"
                                                                        onClick={() => this.cancel(el.index)}
                                                                    >
                                                                    </Button>
                                                                }
                                                            />
                                                        </div>
                                                    }
                                                </Table.Cell>
                                            </Table.Row>))}
                                    </Table.Body>
                                            : this.state.showFiltersOnButton ?
                                    <NoCurrentGradesFilterMessage />
                                    : <Table.Body>
                                                <Table.Row >
                                                    <Table.Cell verticalAlign="middle" colSpan={10} ><NoCurrentGradesMessage /></Table.Cell></Table.Row></Table.Body>}
                                </Table>


                        }
                        {currentPosts.length >0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}
                    </div>
                </Tab.Pane>)
            },
            {
                menuItem: { content: <FormattedMessage id="professorInputGrades.groupGrading" /> },
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <div>
                        {   this.getDataToRender().length !== 0 && <Segment secondary textAlign='center' verticalAlign='middle'>
                            <Header style={IconHeader} floated="right">
                                <Popup
                                    trigger={<Icon circular basic="true" name="info" size='large' />}
                                    content={<p><FormattedMessage id="professorInputGrades.groupGradingInfo" /><b><i><FormattedMessage id="professorInputGrades.groupGradingInfo2" /></i></b><FormattedMessage id="professorInputGrades.groupGradingInfo3" /></p>}
                                    size="small"
                                    data-position="left center"
                                    wide
                                    position="top right"
                                />
                            </Header>
                            <br/>

                            {this.state.loadGrading ?
                                <Loader active inline="centered" />
                                :<Form>
                                    <Form.Group widths='equal'>
                                        <Form.Field/>
                                        <Form.Field>
                                            <Form.Dropdown
                                                placeholder={<FormattedMessage id="professorInputGrades.selectGrade" />}
                                                value={this.state.groupGrade}
                                                onChange={this.handleChange}
                                                name="groupGrade"
                                                options={this.props.marks.filter(el => (el.key_ !== 'nz' && el.key_ !== 'no' && el.key_ !== 'nonp' && el.key_ !== 'f' && el.key_ !== 'not_defended'  && el.key_ !== 'uo' ))}
                                                search
                                                selection
                                                clearable
                                            />
                                        </Form.Field>
                                        <Button color='blue' disabled={!this.state.selectedData.length || !this.state.groupGrade} onClick={this.groupGrading}>
                                            <FormattedMessage id="professorInputGrades.grade" />
                                        </Button>
                                        <Button color='blue' basic='true' onClick={()=>this.setState({selectedData: [], groupGrade: ''})}>
                                            <FormattedMessage id="common.cancelO" />
                                        </Button>
                                        <Form.Field/>

                                    </Form.Group>
                                </Form>}

                        </Segment>}

                        {this.state.loading ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div> :
                            this.getDataToRender().length ?
                                <Table celled selectable compact>
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell width={1} textAlign='center'>
                                                <Checkbox
                                                    type="checkbox"
                                                    name="checkAllButton"
                                                    value={this.state.selectedData.length === this.getDataToRender().length}
                                                    onChange={this.selectAll}
                                                    checked={this.state.selectedData.length === this.getDataToRender().length}
                                                />
                                            </Table.HeaderCell>
                                            <Table.HeaderCell width={2}>
                                                <FormattedMessage id="common.index" />
                                            </Table.HeaderCell>
                                            <Table.HeaderCell>
                                                <FormattedMessage id="common.lastName" />
                                            </Table.HeaderCell>
                                            <Table.HeaderCell>
                                                <FormattedMessage id="common.firstName" />
                                            </Table.HeaderCell>
                                            <Table.HeaderCell colSpan={2}>
                                                <FormattedMessage id="professorInputGrades.studyProgram" />
                                            </Table.HeaderCell>
                                            <Table.HeaderCell>
                                                <FormattedMessage id="professorInputGrades.studentStudyType" />
                                            </Table.HeaderCell>

                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body> { this.getDataToRender().map((el) =>
                                        (<Table.Row
                                                key={el.studentGradedActivityId}
                                                style={HeaderCursor}
                                                warning={this.state.selectedData.find(e => e.studentGradedActivityId === el.studentGradedActivityId)}
                                                onClick={() => this.onSelectRow(el.studentGradedActivityId)}
                                            >
                                                <Table.Cell
                                                    verticalAlign="middle"
                                                    textAlign="center"
                                                >
                                                    <Checkbox
                                                        name={el.studentGradedActivityId}
                                                        type="checkbox"
                                                        checked={this.state.selectedData.findIndex(e => e.studentGradedActivityId === el.studentGradedActivityId) > -1}
                                                    />

                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle" width={2}>
                                                    {el.index}
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle">
                                                    {el.lastName}
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle">
                                                   {el.firstName}
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle" colSpan={2}>
                                                    {

                                                        el.departments ? el.departments.map(e => (<div>

                                                                {e.name === el.studyProgramBasicName?
                                                                    e.name
                                                                    :

                                                                    e.name && e.name !== '-'?
                                                                        //ima odsjek i nije crtica
                                                                        <span>
                                                <strong>{e.name}</strong> <span> {el.studyProgramBasicName && el.studyProgramBasicName !== '-' ? (' | ' + el.studyProgramBasicName) : ''}</span>
                                            </span>
                                                                        :
                                                                        //nema odsjek ili je crtica
                                                                        el.studyProgramBasicName ? el.studyProgramBasicName : ''

                                                                }
                                                            </div>
                                                        )) : el.studyProgramBasicName ? el.studyProgramBasicName :''

                                                    }
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle">
                                                    {el.studyType}
                                                </Table.Cell>
                                            </Table.Row>
                                        ))}
                                    </Table.Body>
                                </Table>
                                : this.state.showFiltersOnButton ?
                                <NoCurrentGradesFilterMessage />
                                : <NoCurrentGradesMessage />

                        }
                    </div>
                </Tab.Pane>)
            }
        ];
        if (this.state.showStudentInfo === true) {
            return (
                <FormattedMessage id="route.studentGradesAndInfo">
                    {(msg) => (<Redirect push to={{ pathname: msg, state: { studentId: this.state.studentId, sspId: this.state.sspId, studyProgramId: this.state.studyProgramId } }}  />)}
                </FormattedMessage>);
        }
        return (
            <div>
                <Tab
                    id="myTab"
                    panes={panes}
                    menu={{
                        secondary: true, pointing: true, color: 'blue', vertical: true, fluid: true, attached: true, tabular: true
                    }}
                    grid={{ paneWidth: 14, tabWidth: 2}}
                    activeIndex={this.state.activeIndex}
                    onTabChange={this.handleTabChange}
                />

            </div>


        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Professor/ProfessorInputGrades/StudentsWithoutGrades.js